export default (dateAttribute) => {
    return Number.isInteger(dateAttribute) ? new Date(dateAttribute * 1000) : new Date(dateAttribute);
}